import { useTranslation } from "react-i18next";

export default function IcoSmug() {
	const { t } = useTranslation();

	return (
		<img
			src="/assets/images/ico-smug.webp"
			alt={t("management_and_monitoring_title")}
			loading="eager"
			width="196"
			height="175"
		/>
	);
}
